import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  height: 250px;
  margin: 0 auto;
`;

export const DisplayAdStartpageLeaderboard: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const { id, adUnitPath, size } = adSlotConfig.Startpage.Leaderboard;
  useDefineSlot({ id, adUnitPath, size, refresh });

  return <AdContainer id={id} />;
};
